
export enum PrimaryColor {
  PURPLE = '#8E42EE',
  ORANGE = '#F78E12',
  PINK = '#EC4899',
  CYAN = '#06B6D4',
  RED = '#FF004D',
  BLUE = '#3C5DE2',
  GREEN = '#24CF35',
  YELLOW = '#F7E217',
}

export enum SecondaryColor {
  PURPLE = '#936DC3',
  ORANGE = '#D98C30',
  PINK = '#D85C99',
  CYAN = '#21A3B9',
  RED = '#CC3361',
  BLUE = '#6173BD',
}

export enum NeutralColor {
  PURPLE = '#968AA6',
  ORANGE = '#A18768',
  PINK = '#AF859A',
  CYAN = '#3A91A0',
  RED = '#9F6073',
  BLUE = '#7A82A4',
}